export function playToastSound(type: 'success' | 'error' | 'info' = 'info') {
  try {
    if (typeof window === 'undefined') return;

    const audio = new Audio('/toast.mp3');

    // Slight tweaks for different notification types
    if (type === 'error') {
      audio.playbackRate = 0.8;
      audio.volume = 0.7;
    } else if (type === 'success') {
      audio.playbackRate = 1.1;
    }

    audio.play().catch((err) => {
      console.debug('Audio play failed (maybe user has not interacted):', err);
    });
  } catch (error) {
    console.debug('Failed to play sound:', error);
  }
}
